import { Box, Typography } from "@mui/material"
import { useDataType } from "../../../hooks/use-data-type";
import { useMapAttributeName } from "../../../hooks/use-map-attribute";
import { ZipDataDto } from "@models/zip-data";

export type ZipInfoPanelData = ZipDataDto & { label: string };

export const ZipInfoPanel = ({ data }: { data?: ZipInfoPanelData }) => {
  const [_, getDataTypeString] = useDataType();
  const [mapAttributeName] = useMapAttributeName();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant='subtitle1' sx={{ textAlign: 'center'}}>{'Zip ' + data?.label}</Typography>
      <Box>
        <Typography 
          variant='body2' 
          style={{ display: 'inline-block' }}
        >
          {mapAttributeName + ':'}
        </Typography>
        <Typography variant='subtitle2' style={{ display: 'inline-block' }} sx={{ marginLeft: 1 }}>
          {getDataTypeString(data?.dataMean)}
        </Typography>
      </Box>
      <Box>
        <Typography 
          variant='body2' 
          style={{ display: 'inline-block' }}
          sx={{ marginBottom: 0 }}
        >
          {'Samples amount:'}
        </Typography>
        <Typography variant='subtitle2' style={{ display: 'inline-block' }} sx={{ marginLeft: 1 }}>
          {data?.dataCount}
        </Typography>
      </Box>
    </Box>
  )
}